<template>
  <div class="contentDetails">
    <NavBar :navBlock="navBlock" :navtitle="navtitle" :pageBack="true"></NavBar>

    <div class="detailsContent">
      <div class="tableWrap table">
        <el-table
          :data="obtain"
          border
          style="width:100%;"
          :header-cell-style="{ background: '#eeeeee', color: '#000000' }"
        >
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in obtaintabs"
            :prop="item.props"
            :label="item.label"
            :key="index"
          >
            <template slot-scope="scope">
              <div v-if="!scope.row[item.props]">
                -
              </div>
              <div v-else-if="item.props == 'createTime'">
                {{ $dayjs(scope.row.createTime).format("YYYY-MM-DD HH:mm:ss") }}
              </div>
              <div v-else>
                {{ scope.row[item.props] }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                v-if="scope.row.status !== '不可越級操作'"
                @click="
                  editStatus(scope.$index)
                "
                >管理
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-table
          :data="notObtain"
          border
          style="width:100%;"
          :header-cell-style="{ background: '#eeeeee', color: '#000000' }"
        >
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in notObtaintabs"
            :prop="item.props"
            :label="item.label"
            :key="index"
          >
            <template slot-scope="scope">
              <div v-if="!scope.row[item.props]">
                -
              </div>
              <div v-else-if="item.props == 'createTime'">
                {{ $dayjs(scope.row.createTime).format("YYYY-MM-DD HH:mm:ss") }}
              </div>
              <div v-else>
                {{ scope.row[item.props] }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                v-if="scope.row.status !== '不可越級操作'"
                @click="
                  noStatus(scope.$index)
                "
                >管理
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog
          :title="bagetitle"
          :visible.sync="editshow"
          width="5.6rem"
          :close-on-press-escape="false"
          :close-on-click-modal="false"
        >
     <div style="padding-left: 50px;">
      <div style="display: flex;align-items: center;">
        <div>
          <img :src="img" alt="" class="bageimg" v-if="obtaintype=='yes'">
          <img :src="imgGray" alt="" class="bageimg" v-else>
        </div>
        <div style="font-size: 14px;font-weight: bold;">
          {{ bagetext }}
        </div>
      </div>
      <div class="flexrow">
            <div>
              獲得狀態
            </div>
        <div style="margin-left: 15px;">
          <el-radio-group v-model="bagetype" @change="handbage">
              <el-radio :label="1">已獲得</el-radio>
              <el-radio :label="2">未獲得</el-radio>
            </el-radio-group>
        </div>
          </div>
          <div class="flexrow" v-if="bagetype == 1">
            <div>
              徽章等級
            </div>
          <div style="margin-left: 15px;">
            <el-select v-model="grade" placeholder="请选择" @change="handgrade">
              <el-option
                v-for="item in options"
                :key="item.badgeId"
                :label="item.status == 2&&Number(item.subName)>grade?item.subName+'(不可越級操作)':item.subName"
                :disabled="item.status!=0"
                :value="item.subName"
              >
              </el-option>
            </el-select>
          </div>
          </div>
          <div class="flexrow" v-if="bagetype == 1">
            <div>
              獲得時間
            </div>
           <div style="margin-left: 15px;">
            <el-date-picker
              v-model="grantTime"
              type="datetime"
              placeholder="請選擇日期"
            >
            </el-date-picker>
           </div>
          </div>
     </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" style="background:#6c3dea;color:#ffffff;" @click="checkbage">修改</el-button>
          </span>
        </el-dialog>

        <el-dialog
          title="提示信息"
          :visible.sync="deleteshow"
          width="5.6rem"
          :close-on-press-escape="false"
          :close-on-click-modal="false"
        >
          <div style="marginTop:30px">确定删除该徽章？ 删除后不可恢复！</div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="deleteshow = false">取消</el-button>
            <el-button type="primary" @click="badgeDelete">確認</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";
import dayjs from "dayjs";

export default {
  name: "badgeManager",
  components: {
    NavBar,
    DiaMess
  },
  data() {
    return {
      navBlock: "會員  /  會員列表",
      navtitle: "徽章管理",
      id: this.$route.query.id,
      notObtain: [],
      obtain:[],
      dialogVisible: false,
      grantTime: "",
      editshow: false,
      deleteshow: false,
      currentId: "",
      decurrentId:'',
      obtaintype:'',
      img:'',
      statusType:'',
      imgGray:'',
      bagetext:'',
      bagetitle:'',
      grade: "",
      options: [],
      bagetype: "",
      notObtaintabs: [
        {
          label: "未獲得徽章",
          props: "activityName"
        },
        {
          label: "等級",
          props: "grade"
        },
        {
          label: "獲得時間",
          props: "createTime"
        }
      ],
      obtaintabs: [
        {
          label: "已獲得徽章",
          props: "activityName"
        },
        {
          label: "等級",
          props: "grade"
        },
        {
          label: "獲得時間",
          props: "createTime"
        }
      ]
    };
  },
  created() {
    this.getTable();
  },
  methods: {
    getTable() {
      let _this = this;
      _this
        .$get(
          `/request/badge/userBadgeList/v2?userId=${this.id}`,
          {},
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code === "00000") {
            _this.notObtain = res.data.notObtain;
            _this.obtain = res.data.obtain;
          } else {
            _this.dialogVisible = true;
            _this.$propMessage(res.message, "error", function() {
              _this.dialogVisible = false;
            });
          }
        });
    },
    editStatus(index) {
      this.editshow = true;
      this.obtaintype='yes'
      this.bagetype = 1;
      this.grade = this.obtain[index].grade;
      this.grantTime=this.obtain[index].createTime
      this.options = this.obtain[index].userBadgeBodyList;
      let bageid=this.options.filter(item => {
        return item.subName == this.grade;
      });
      this.currentId=bageid[0].badgeId;
      this.statusType=bageid[0].status
      this.decurrentId=bageid[0].badgeId;
      this.img=bageid[0].img;
      this.imgGray=bageid[0].imgGray;
      this.bagetitle=this.obtain[index].activityName
      this.bagetext=bageid[0].obtainingMethod
   
      
    },
    noStatus(index) {
      this.currentId=''
      this.grantTime=''
      this.editshow = true;
      this.grade='',
      this.grantTime=''
      this.obtaintype='no'
      this.bagetype = 2;
      this.options = this.notObtain[index].userBadgeBodyList;
      this.imgGray=this.options[0].imgGray;
      this.bagetitle=this.notObtain[index].activityName
      this.bagetext=this.options[0].obtainingMethod
    },
    //選擇發放
    handbage(e) {
      this.bagetype = e;
    },


    formatTime(time) {
      let date = new Date(time);
      var year = date.getFullYear(); //得到年份
      var month = date.getMonth(); //得到月份
      var day = date.getDate(); //得到日期
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      return year + "-" + month + "-" + day;
    },
  
    badgeSave() {
      let _this = this;
      let grantTime = "";
      console.log(_this.currentId);
      // return
      
      if(!_this.currentId){
        _this.$warnMessage("請選擇徽章等级");
        return
      }
      
      if (_this.grantTime){
        grantTime =this.$dayjs(_this.grantTime).format("YYYY-MM-DD HH:mm:ss")
      }else{
        _this.$warnMessage("請選擇獲得時間");
        return
      }
      _this
        .$get(
          `/request/badge/save?userId=${_this.id}&badgeId=${_this.currentId}&grantTime=${grantTime}`,
          {},
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
      
          _this.dialogVisible = true;
          if (res.code === "00000") {
            this.editshow = false;
            _this.$propMessage("發放成功", "success", function() {
              _this.dialogVisible = false;
              _this.getTable();
            });
          } else {
            _this.$propMessage(res.message, "error", function() {
              _this.dialogVisible = false;
            });
          }
        });
    },
    badgeDelete() {
      let _this = this;
      let badgeId=''
      if(_this.statusType==1){
        badgeId=_this.currentId
      }else{
        badgeId=_this.decurrentId
      }
      _this
        .$get(
          `/request/badge/delete?userId=${_this.id}&badgeId=${badgeId}`,
          {},
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          _this.dialogVisible = true;
          if (res.code === "00000") {
            this.deleteshow = false;
            this.editshow=false
            _this.$propMessage("刪除成功", "success", function() {
              _this.dialogVisible = false;
              _this.getTable();
            });
          } else {
            _this.$propMessage(res.message, "error", function() {
              _this.dialogVisible = false;
            });
          }
        });
    },
    checkbage(){
      if(this.bagetype==1){
        this.badgeSave()
      }else{
        this.deleteshow=true
      }
    },
    handgrade(e){  
    let data=this.options.filter((v)=>{
      return v.subName==e
      });
      this.grantTime=data[0].createTime;
      this.currentId=data[0].badgeId;
      this.img=data[0].img;
      this.bagetext=data[0].obtainingMethod;
      this.imgGray=data[0].imgGray;
      // this.statusType=data[0].status
    }
   
    
    
  }
};
</script>

<style lang="less">
.contentDetails {
  .detailsContent {
    background-color: #fafafd;

    .tableWrap {
      background: #fff;
      border-radius: 0.16rem;
      margin-top: 0;
      margin-bottom: 0.5rem;
      overflow: auto;

      .el-table td,
      .el-table th.is-leaf {
        border-right: 4px solid #fafafd;
        border-bottom: 4px solid #fafafd;
      }

      .el-table td:last-child {
        border-right: none;
      }

      .el-table th:nth-last-child(1) {
        border-right: none;
      }
    }
    .el-dialog__title {
      font-size: 12px;
      line-height: 1px;
      color: #303133;
    }
    .el-dialog__header {
      padding: 15px;
      // box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    }
    .el-dialog__footer {
      text-align: center;
      padding-bottom: 60px;
      .dialog-footer {
        button {
          width: 1.28rem !important;
          background: @mainColor;
          border: none;
          color: #fff;
          border-radius: 4px;
        }

        button:nth-child(1) {
          background: rgba(232, 230, 240, 1);
          color: rgba(147, 142, 164, 1);
        }

        button:nth-child(2) {
          margin-left: 0.6rem;
        }
      }
    }
  }
}
.flexrow {
  display: flex;
  margin-top: 15px;
}
.bageimg{
  width: 135px;
  height: 140px;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/badgeManager.vue